lmApp.service('SubscriberResource', ['$resource', function ($resource) {
  return $resource('/discovery:80/sdp/v2/subscribers',
    null,
    {
      get: {
        url: '/discovery:80/sdp/v2/subscribers?$expand=groups',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      create: {
        url: '/discovery:80/sdp/v2/subscribers',
        method: 'POST',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      update: {
        url: '/discovery:80/sdp/v2/subscribers/:id',
        method: 'PATCH',
        params: {
          id: '@id'
        },
        transformRequest: function (data) {
          var body = _.pick(data, [
            'blocked',
            'address_country',
            'address_region',
            'address_city',
            'address_zipcode',
            'address_line1',
            'address_line2',
            'first_name',
            'last_name',
            'contact_phone',
            'contact_email',
            'pc_pin',
            'npvr_limit',
            'playback_session_limit'
          ]);

          if (body.hasOwnProperty('npvr_limit')) body['npvr_limit'] = Number(body['npvr_limit']);
          if (body.hasOwnProperty('playback_session_limit')) body['playback_session_limit'] = Number(body['playback_session_limit']);
          if (data.hasOwnProperty('_groups')) body['groups'] = data['_groups'];

          return angular.toJson(body);
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      remove: {
        url: '/discovery:80/sdp/v2/subscribers/:id',
        method: 'DELETE',
        params: {
          id: '@id'
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      setPassword: {
        url: '/discovery:80/sdp/v2/subscribers/:id/commands/change-password',
        method: 'POST',
        params: {
          id: '@id'
        },
        transformRequest: function (data) {
          var params = [];
          for (var v in data)
            params.push(encodeURIComponent(v) + "=" + encodeURIComponent(data[v]));
          return params.join("&")
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken'),
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    });
}]);
